import { render, staticRenderFns } from "./personnelcald.vue?vue&type=template&id=6ca38f07&scoped=true&"
import script from "./personnelcald.vue?vue&type=script&lang=js&"
export * from "./personnelcald.vue?vue&type=script&lang=js&"
import style0 from "./personnelcald.vue?vue&type=style&index=0&id=6ca38f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca38f07",
  null
  
)

export default component.exports